<template>
  <div>
    <b-modal ref="modalReleaseMeliFlex" id="modalReleaseMeliFlex" no-close-on-backdrop centered
      modal-class="dialog-600" >
      <template #modal-title>
        <b>{{ dataModal.title }}</b>
      </template>
      <b-form-group :label="label" stacked>
        <b-form-radio-group v-model="selected" >
          <b-form-radio class="mt-2 ml-3" v-for="(option, index) in dataModal.fields[0].options" :key="index" :value="option.id">
            <div>
              <div :style="option.textStyles">{{option.text}}</div>
              <div :style="option.contentStyles">{{option.content}}</div>
            </div>
        </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <template #modal-footer>
        <b-button :variant="dataModal.variantButton || 'warning'" @click="onSend" :disabled="dataModal.loading && dataModal.isEnableButton">
        <b-spinner v-show="dataModal.loading" small></b-spinner>
        {{$t(dataModal.nameButton)}}
        </b-button>
      </template>
      </b-modal>
  </div>
</template>
<script>

export default {
  data() {
    return {
      selected: 1
    }
  },
  props: {
    dataModal: {
      type: Object,
      require: true
    }
  },
  computed: {
    label() {
      return this.dataModal.fields[0].label || 'none'
    }
  },
  methods: {
    onSend() {
      this.$emit('onSend', this.selected)
      this.$bvModal.hide('modalReleaseMeliFlex')
    }
  }
}
</script>
<style>

</style>